import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
const DownloadIcon = (props: any) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <path d="M12,2C6.49,2,2,6.49,2,12s4.49,10,10,10s10-4.49,10-10S17.51,2,12,2z M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8 S16.41,20,12,20z M14.59,8.59L16,10l-4,4l-4-4l1.41-1.41L11,10.17V6h2v4.17L14.59,8.59z M17,17H7v-2h10V17z" />
        </g>
      </g>
    </SvgIcon>
  );
};
export default DownloadIcon;
